import React from 'react';
import { Award, Users, Target, TrendingUp } from 'lucide-react';

const About = () => {
  const highlights = [
    {
      icon: Award,
      title: 'Excellence',
      description: 'Award-winning designs recognized for innovation and quality'
    },
    {
      icon: Users,
      title: 'Expert Team',
      description: 'Skilled architects and designers with decades of experience'
    },
    {
      icon: Target,
      title: 'Client-Focused',
      description: 'Tailored solutions that reflect your vision and context'
    },
    {
      icon: TrendingUp,
      title: 'Innovation',
      description: 'Fresh ideas combined with proven methodologies'
    }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-black mb-4">
            About <span className="text-yellow-600">ARCHIFAB</span>
          </h2>
          <div className="w-24 h-1 bg-yellow-600 mx-auto"></div>
        </div>

        {/* Main Content */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Text Content */}
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-black leading-tight">
              Crafting Architectural Excellence Since 1992
            </h3>
            
            <p className="text-lg text-gray-700 leading-relaxed">
              ARCHIFAB is a new generation design firm providing architecture, interior design, planning services in residential, commercial and industrial sectors. As part of Interfab interior designers & decorators, founded in 1992, we bring over three decades of expertise in creating exceptional spaces.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed">
              Our design philosophy hinges on conceiving design methodologies addressing the underlying parameters that shape a project. We find suitable organization and form that reflects the aspects of the users and the context in which it exists.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed">
              We have successfully delivered turnkey solutions across various domains including residential, commercial, industrial, institutional and hospitality sectors, covering over <strong>10,00,000 sq.ft</strong> of area across major cities like Chennai, Bangalore, Hyderabad, Vishakhapatnam, and Yercaud.
            </p>

            <div className="flex items-center gap-4 pt-4">
              <div className="w-16 h-1 bg-yellow-600"></div>
              <span className="text-sm font-semibold text-gray-600 uppercase tracking-wider">Since 1992</span>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-sm overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1574848296471-28f79a036f79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzYwOTQ4NzEyfDA&ixlib=rb-4.1.0&q=85"
                alt="Modern Architecture"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 border-4 border-yellow-600 rounded-sm -z-10"></div>
          </div>
        </div>

        {/* Highlights Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-20">
          {highlights.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="text-center p-6 rounded-sm hover:shadow-xl transition-all duration-300 group border border-gray-100 hover:border-yellow-600"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-yellow-50 rounded-full mb-4 group-hover:bg-yellow-600 transition-colors duration-300">
                  <Icon className="w-8 h-8 text-yellow-600 group-hover:text-white transition-colors duration-300" />
                </div>
                <h4 className="text-xl font-bold text-black mb-2">{item.title}</h4>
                <p className="text-gray-600">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;